export enum ModuleTypeEnums {
  Users = 1,
  Organisation = 2,
  ProductionHistoryAudit = 3,
  InternalAuditDocument = 6,
  QCVSAuditDocument = 7
}

export const USER_SALUATION = [
  { name: 'Mr.', value: 1 },
  { name: 'Mrs.', value: 2 },
  { name: 'Miss', value: 3 },
  { name: 'Ms.', value: 4 },
  { name: 'Dr.', value: 5 },
];

export const SaveMessage = 'Saved Successfully.';

export const UpdateMessage = 'Updated Successfully.';

export const ArchivedMessage = 'Archived Successfully.';

export const UnArchivedMessage = 'Unarchived Successfully.';

export const RemovedMessage = 'Removed Successfully.';

export const ORGANIZATION_STATUS = [
  { name: 'Pending', value: 1 },
  { name: 'Awaiting Payments', value: 2 },
  { name: 'Overdue', value: 3 },
  { name: 'Current', value: 4 },
];

export enum OrganizationStatus {
  Pending = 1,
  AwaitingPayments = 2,
  Overdue = 3,
  Current = 4,
  Rejected = 5,
}

export enum ApprovalStatus {
  Approve = 1,
  Reject = 2,
}

export const AUDIT_VALIDITY = [
  { name: '4 Months', value: 1 },
  { name: '6 Months', value: 2 },
];

export const MARKET = [
  { name: 'US', value: 1 },
  { name: 'UK', value: 2 },
  { name: 'EU', value: 3 },
];

export const COUNTRY_REGION = [
  { name: 'US', value: 1 },
  { name: 'UK', value: 2 },
  { name: 'EU', value: 3 },
  { name: 'NZ', value: 4 },
];

export enum Region {
  US = 1,
  UK = 2,
  EU = 3,
  NZ = 4
}

export const CERTIFICATE_OUTPUT = [
  { name: 'Print', value: 1 },
  { name: 'PDF', value: 2 },
];

export const QUOTA_MODEL = [
  { name: 'GQA', value: 1 },
  { name: 'FCFS', value: 2 },
];

export enum QuotaModel {
  GQA = 1,
  FCFS = 2,
}

export const FINANCIAL_QUARTER = [
  { name: 'Q1 (Oct-Dec)', value: 1 },
  { name: 'Q2 (Jan-Mar)', value: 2 },
  { name: 'Q3 (Apr-Jun)', value: 3 },
  { name: 'Q4 (Jul-Sep)', value: 4 },
];


export const APPLICATION_FEE = 45;

export const EXPORT_MARKET = [
  {
    label: 'US beef and veal',
    value: 1,
  },
  {
    label: 'EU sheepmeat and goatmeat',
    value: 2,
  },
  {
    label: 'EU high-quality beef',
    value: 3,
  },
  {
    label: 'UK sheepmeat and goatmeat',
    value: 4,
  },
  {
    label: 'UK high-quality beef',
    value: 5,
  },
  {
    label: 'Other',
    value: 6,
  },
];

export enum CalenderEventEnum {
  ProductionHistoryDueEveryMonth = 1,
  QCVSInternalAuditDueEveryMonth = 5,
  PHLockApril = 6,
  PHLockOctober = 7
}

export enum ProductionHistoryAuditStatus {
  NotDueYet = 1,
  AuditDue = 2,
  AuditorSignedOff = 3,
  NZMBSignedOff = 4
}

export enum ProductionHistoryMonthlyAuditStatus {
  Due = 1,
  OverDue = 2,
  Submitted = 3,
}

export const enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export const USER_INVITE_STATUS = [
  { name: 'Yes', value: true },
  { name: 'No', value: false },
];

export const AUDIT_OUTCOME = [
  { name: 'Full Compliance', value: 1 },
  { name: 'Part Compliance', value: 2 },
  { name: 'Non - Compliance', value: 3 },
];

export const AUDIT_STATUS = [
  // { name: 'Due', value: 1 },
  { name: 'Completed', value: 2 },
  { name: 'Finalised', value: 3 },
];


export const EMAIL_TYPE = [
  { name: 'Custom', value: 1 },
  { name: 'User', value: 2 },
  { name: 'Organisation', value: 3 },
  { name: 'Production History', value: 4 },
  { name: 'Production History Audit', value: 5 },
  { name: 'Production History Transfer', value: 6 },
  { name: 'Quota Application', value: 7 },
  { name: 'Quota Allocation', value: 8 },
  { name: 'Handback', value: 9 },
  { name: 'Quota Transfer', value: 10 },
  { name: 'Certificate', value: 11 },
  { name: 'QCVS Audit', value: 12 },
  // { name: 'Finance', value: 13 },
  { name: 'Report', value: 14 },
]

export enum HandbackWindowStatus {
  HandbackNotRequired = 1,
  NotStarted = 2,
  Started = 3,
  Closed = 4
};

export enum ReallocationType {
  Redistribution = 1,
  FCFS = 2,
}

export enum FinalizedAudit {
  NoAuditCompleted = 0,
  FirstAuditComplete = 1,
  SecondAuditComplete = 2,
  AllAuditsComplete = 3
}

export enum HandbackAllocationStatus {
  NotProcessed = 1,
  Confirmed = 2,
  Committed = 3,
}

export enum UserStatus {
  Pending = 1,
  Active = 2,
  Archived = 3
}

export enum QuotaTransferApprovalStatus {
  Pending = 1,
  TransfereeApproved = 2,
  NZMBApproved = 3,
  Reject = 4
}

export const QUOTA_MANAGER_ACTIONS_DROPWOWN = [
  {
    name: "Quota Allocation (VPF)",
    value: 1
  },
  {
    name: "Quota Application (FPF)",
    value: 2
  },
  {
    name: "Certificate",
    value: 3
  },
  {
    name: "Handback",
    value: 4
  },
  // {
  //   name: "Handback Reallocation",
  //   value: 5
  // },
  {
    name: "Journal",
    value: 6
  },
  {
    name: "Production History Audit",
    value: 7
  },
  {
    name: "QCVS Audit",
    value: 8
  },
  {
    name: "Registration",
    value: 9
  },
  {
    name: "Renewal",
    value: 10
  },
  {
    name: "Transfer",
    value: 11
  },
  {
    name: "PH Transfer",
    value: 12
  },
  {
    name: "Special Levy 1",
    value: 13
  },
  {
    name: "Special Levy 2",
    value: 14
  },
  {
    name: "Penalty Redistribution",
    value: 15
  },
  {
    name: "Journal (VPF)",
    value: 16
  },
  {
    name: "Journal (Special Levy 1)",
    value: 17
  },
  {
    name: "Journal (Special Levy 2)",
    value: 18
  },
]

export const QUOTA_MANAGER_ACTIONS_LABLE = [
  {
    name: "Quota Allocation",
    value: 1
  },
  {
    name: "Quota Application (FPF)",
    value: 2
  },
  {
    name: "Certificate",
    value: 3
  },
  {
    name: "Handback",
    value: 4
  },
  // {
  //   name: "Handback Reallocation",
  //   value: 5
  // },
  {
    name: "Journal",
    value: 6
  },
  {
    name: "Production History Audit",
    value: 7
  },
  {
    name: "QCVS Audit",
    value: 8
  },
  {
    name: "Registration",
    value: 9
  },
  {
    name: "Renewal",
    value: 10
  },
  {
    name: "Transfer",
    value: 11
  },
  {
    name: "PH Transfer",
    value: 12
  },
  {
    name: "Special Levy 1",
    value: 13
  },
  {
    name: "Special Levy 2",
    value: 14
  },
  {
    name: "Penalty Redistribution",
    value: 15
  },
  {
    name: "Journal Allocation",
    value: 16
  },
  {
    name: "Journal (Special Levy 1)",
    value: 17
  },
  {
    name: "Journal (Special Levy 2)",
    value: 18
  },
]

export const QUOTA_SPECIFIC_MANAGER_ACTIONS_DROPDOWN = [
  {
    name: "Quota Allocation",
    value: 1
  },
  {
    name: "Quota Application (FPF)",
    value: 2
  },
  {
    name: "Certificate",
    value: 3
  },
  {
    name: "Handback",
    value: 4
  },
  // {
  //   name: "Handback Reallocation",
  //   value: 5
  // },
  // Task 1211: Quota Manager / Journal filter needs to be retired ?
  // {
  //   name: "Journal",
  //   value: 6
  // },
  {
    name: "Journal Allocation",
    value: 16
  },
  {
    name: "Penalty Redistribution",
    value: 15
  },
  {
    name: "Transfer",
    value: 11
  },
  // {
  //   name: "Special Levy 1",
  //   value: 13
  // },
  // {
  //   name: "Special Levy 2",
  //   value: 14
  // },

  // {
  //   name: "Journal (Special Levy 1)",
  //   value: 17
  // },
  // {
  //   name: "Journal (Special Levy 2)",
  //   value: 18
  // },
]

export const NON_QUOTA_SPECIFIC_MANAGER_ACTIONS_DROPDOWN = [

  {
    name: "Production History Audit",
    value: 7
  },
  {
    name: "QCVS Audit",
    value: 8
  },
  {
    name: "Registration",
    value: 9
  },
  {
    name: "Renewal",
    value: 10
  },
  {
    name: "PH Transfer",
    value: 12
  },
]

export enum QuotaManagerAction {
  QuotaAllocationVPF = 1,
  QuotaApplicationFPF = 2,
  Certificate = 3,
  Handback = 4,
  HandbackReallocation = 5,
  Journal = 6,
  ProductionHistoryAudit = 7,
  QCVSAudit = 8,
  Registration = 9,
  Renewal = 10,
  Transfer = 11,
  PHTransfer = 12,
  SpecialLevy1 = 13,
  SpecialLevy2 = 14,
  JournalPenalty = 15,
  JournalVPF = 16,
  JournalSpecialLevy1 = 17,
  JournalSpecialLevy2 = 18,
}

export const VOYAGE_TYPE_LIST = [
  { name: 'Air Freight', value: 1 },
  { name: 'Sea Freight', value: 2 },
];

export enum VoyageType {
  AirFreight = 1,
  SeaFreight = 2
}

export const QUOTA_TRANSACTION_TYPE = [
  { name: 'Credit', value: 1 },
  { name: 'Debit', value: 2 },
]

export enum QuotaTransactionType {
  Credit = 1,
  Debit = 2
}

export const QUOTA_MANAGER_REGISTRATION_STATUS = [
  {
    name: 'Pending',
    statusClass: "allocation-status-pill-info",
    value: 1,
  },
  {
    name: 'Awaiting Payment',
    statusClass: "allocation-status-pill-warning",
    value: 2,
  },
  {
    name: 'Overdue',
    statusClass: "allocation-status-pill-danger",
    value: 3,
  },
  {
    name: 'Current',
    statusClass: "allocation-status-pill-success",
    value: 4,
  },
  {
    name: 'Cancelled',
    statusClass: "allocation-status-pill-danger",
    value: 5,
  },
]

export const QUOTA_MANAGER_RENEWAL_STATUS = [
  {
    name: 'Due',
    statusClass: "allocation-status-pill-info",
    value: 1,
  },
  {
    name: 'Current',
    statusClass: "allocation-status-pill-success",
    value: 2,
  },
  {
    name: 'Overdue',
    statusClass: "allocation-status-pill-warning",
    value: 3,
  },
]

export const QUOTA_MANAGER_QUOTA_APPLICATION_FPF_STATUS = [
  {
    name: 'Submitted',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'In Progress',
    statusClass: "allocation-status-pill-info",
    value: 2,
  },
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
]

export const QUOTA_MANAGER_QUOTA_ALLOCATION_VPF_STATUS = [
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 1,
  }
]

export const QUOTA_MANAGER_QUOTA_TRANSFER_STATUS = [
  {
    name: 'Awaiting Acceptance',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'Awaiting Approval',
    statusClass: "allocation-status-pill-warning",
    value: 2,
  },
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
  {
    name: 'Cancelled',
    statusClass: "allocation-status-pill-danger",
    value: 4,
  },
]

export const QUOTA_MANAGER_HANDBACK_STATUS = [
  {
    name: 'Submitted',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'Confirmed',
    statusClass: "allocation-status-pill-success",
    value: 2,
  },
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
]

export const QUOTA_MANAGER_HANDBACK_RE_ALLOCATION_STATUS = [
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 1,
  }
]

export const QUOTA_MANAGER_PRODUCTION_HISTORY_AUDIT_STATUS = [
  {
    name: 'Open NCs',
    statusClass: "allocation-status-pill-info",
    value: 1,
  },
  {
    name: 'Awaiting Signoff',
    statusClass: "allocation-status-pill-warning",
    value: 2,
  },
  {
    name: 'Finalised',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
]

export const QUOTA_MANAGER_QCVS_AUDIT_STATUS = [
  {
    name: 'Pass',
    statusClass: "allocation-status-pill-success",
    value: 1,
  },
  {
    name: 'Fail',
    statusClass: "allocation-status-pill-danger",
    value: 2,
  }
]

export const QUOTA_MANAGER_JOURNAL_STATUS = [
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 1,
  }
]

export const QUOTA_MANAGER_CERTIFICATE_STATUS = [
  {
    name: 'Requires Attention',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'Pending Approval',
    statusClass: "allocation-status-pill-warning",
    value: 2,
  },
  {
    name: 'Pending Release',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
  {
    name: 'Released',
    statusClass: "allocation-status-pill-success",
    value: 4,
  },
  {
    name: 'Cancellation Requested',
    statusClass: "allocation-status-pill-danger",
    value: 5,
  },
  {
    name: 'Cancelled',
    statusClass: "allocation-status-pill-danger",
    value: 6,
  },
]

export const PH_TRANSFER_STATUS = [
  {
    name: 'Pending',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'Completed',
    statusClass: "allocation-status-pill-success",
    value: 2,
  },
  {
    name: 'Rejected',
    statusClass: "allocation-status-pill-danger",
    value: 3,
  },
]

export const QUOTA_APPLICANT_TYPE = [
  { name: 'New Entrant (Yr-1)', value: 1 },
  { name: 'New Entrant (Yr-2)', value: 2 },
  { name: 'New Entrant (Yr-3)', value: 3 },
  { name: 'Existing', value: 4 },
]

export enum QuotaApplicantType {
  NewEntrant_1 = 1,
  NewEntrant_2 = 2,
  NewEntrant_3 = 3,
  Existing = 4
}

export const enum ProductionHistoryAuditProgressStatus {
  NotYetCompleted = 1,
  InProgress = 2,
  SignOffRequired = 3,
  Finalized = 4
}

export enum ProductionHistorySubmissionStatus {
  DueNow = 1,
  Submitted = 2,
  NotCompleted = 3,
}

export const ORGANIZATION_STATUS_QM = [
  { name: 'Pending', value: 1 },
  { name: 'Awaiting Payments', value: 2 },
  { name: 'Overdue', value: 3 },
  { name: 'Current', value: 4 },
  { name: 'Cancelled', value: 5 },
];

export enum JournalType {
  SpecialArrangement = 1,
  Penalty = 2
}

export enum DebitFrom {
  Pool = 1,
  ExistingExporter = 2
}

export const CERTIFICATE_STATUS = [
  {
    name: 'Requires Attention',
    statusClass: "allocation-status-pill-warning",
    value: 1,
  },
  {
    name: 'Pending Approval',
    statusClass: "allocation-status-pill-warning",
    value: 2,
  },
  {
    name: 'Pending Release',
    statusClass: "allocation-status-pill-success",
    value: 3,
  },
  {
    name: 'Released',
    statusClass: "allocation-status-pill-success",
    value: 4,
  },
  {
    name: 'Cancellation Requested',
    statusClass: "allocation-status-pill-danger",
    value: 5,
  },
  {
    name: 'Cancelled',
    statusClass: "allocation-status-pill-danger",
    value: 6,
  },
]

export const CERTIFICATE_LINE_ITEMS_TYPE = [
  { name: 'CTN', value: 1 },
  { name: 'CCS', value: 2 },
]

export enum AuditOutcome {
  Pass = 1,
  Fail = 2,
}

export const AUDIT_VISIT_TYPE = [
  { name: 'Scheduled', value: 1 },
  { name: 'Unannounced/unscheduled', value: 2 },
  { name: 'Additional', value: 3 },
]

export const AUDIT_SPECIES_TYPE = [
  { name: 'Bovine', value: 2 },
  { name: 'Ovine/Caprine', value: 1 },
]

export const AUDIT_VALIDITY_PERIOD = [
  { name: '4 Month', value: 1 },
  { name: '6 Month', value: 2 },
]

export const AUDIT_QUOTA_STATUS = [
  // { name: '--', value: 0 },
  { name: 'Satisfactory', value: 1 },
  { name: 'Non-Satisfactory', value: 2 },
]

export enum AuditQuotaStatus {
  None = 0,
  Satisfactory = 1,
  NonSatisfactory = 2,
  Overdue = 3
}

export enum CertificateStatus {
  RequireAttention = 1,
  PendingApproval = 2,
  PendingRelease = 3,
  Release = 4,
  CancellationRequested = 5,
  Cancelled = 6
}

export const CERTIFICATE_ISSUE_LOCATION = [
  { name: 'Brussels', label: 'BRS', value: 1 },
  { name: 'Wellington', label: 'WGTN', value: 2 },
]

export enum IssueLocation {
  Brussels = 1,
  Wellington = 2
}

export enum CertificateChangeLogType {
  ChangeLog = 1,
  StatusLog = 2,
  USCBPLog = 3
}

export const CERTIFICATE_CHANGE_LOG_TYPE = [
  { name: 'Change Log', value: CertificateChangeLogType.ChangeLog },
  { name: 'Status Log', value: CertificateChangeLogType.StatusLog },
  { name: 'USCBP Log', value: CertificateChangeLogType.USCBPLog },
]

export const FILTERTS_ = 'FILTERS_';

export const CERTIFICATE_MANAGER_FILTER = 'CERTIFICATE_MANAGER_FILTER';

export const QUOTA_MANAGER_FILTER = 'QUOTA_MANAGER_FILTER';

export const ACTIVE_ORGANISATION_ID_KEY = 'access_token';

export const CHANGE_LOG_MODULE_TYPE = [
  { name: 'Organisation', value: 2 },
  { name: 'Quota Manager', value: 1 },
  { name: 'User', value: 4 },
  { name: 'Quota', value: 5 },
  { name: 'Certificate', value: 6 },
]

export enum ChangeLogModuleType {
  QuotaManager = 1,
  Organisation = 2,
  User = 4,
  Quota = 5,
  Certificate = 6
}

export enum QuotaTransferWeightType {
  Tonnes = 1,
  Kg = 2
}

export const WEIGHT_TYPE = [
  { name: 'Tonnes', value: 1 },
  { name: 'Kg', value: 2 },
]

export const BC_TRANSACTION_MODULE_TYPE = [
  { name: 'Month Wise', value: 1 },
  { name: 'Organisation Registration/Renewal', value: 2 },
  { name: 'Quota Allocation', value: 3 },
  { name: 'Quota Application', value: 4 },
  { name: 'Special Arrangement', value: 5 },
  { name: 'Courier Charges', value: 6 }
]

export const FILE_NAME_REGEX = /filename\*?=(?:UTF-8''|")?([^";\n]+)/i

export enum USCBP_ProcessStatus {
  New = 1,
  EditCertficate = 2,
  Completed = 3,
  ResendNeeded = 4
}

export enum ExternalApprovalStatus {
  Sent = 1,
  Pass = 2,
  Failed = 3
}

export const USCBP_STATUS = [
  { name: 'Sent', value: ExternalApprovalStatus.Sent },
  { name: 'Acknowledged', value: ExternalApprovalStatus.Failed },
  { name: 'Successful', value: ExternalApprovalStatus.Pass },
]

export enum ReportType {
  Report_1 = 1,
  Report_3 = 3,
  Report_5 = 5,
  Report_6 = 6,
  Report_20a = 9,
  Report_20b = 10,
  Report_20 = 11
}

export enum ReportBuilderType {
  Certificate = 1,
  Transaction = 2
}

export enum ExporterFilter {
  AllExporter = 1,
  Individual = 2
}

export const CERTIFICATE_COLUMNS = [
  { name: 'Certificate Number', value: 1 },
  { name: 'Quota Name', value: 2 },
  { name: 'Requested Date', value: 3 },
  { name: 'Certificate Valid From Date', value: 4 },
  { name: 'Certificate Expiry Date', value: 5 },
  { name: 'Exporter', value: 6 },
  { name: 'Plant Codes', value: 7 },
  { name: 'Exporter Reference', value: 8 },
  { name: 'Importer Name', value: 9 },
  { name: 'Country', value: 10 },
  { name: 'Voyage', value: 11 },
  { name: 'Departure Port', value: 12 },
  { name: 'Departure Date', value: 13 },
  { name: 'Arrival Port', value: 14 },
  { name: 'Arrival Date', value: 15 },
  { name: 'Certificate Status', value: 16 },
  { name: 'Approved By', value: 17 },
  { name: 'Approved Date', value: 18 },
  { name: 'Issued By', value: 19 },
  { name: 'Issue Date', value: 20 },
  { name: 'Cancellation Date', value: 21 },
  { name: 'Cancellation By', value: 22 },
  { name: 'Cancellation Request By', value: 23 },
  { name: 'Cancellation Reason', value: 24 },
  { name: 'Issue Location', value: 25 },
  { name: 'Multiple Use Certificate', value: 26 },
  { name: 'Notes', value: 27 },
  { name: 'Total Gross Mass', value: 28 },
  { name: 'Total Net Mass', value: 29 },
  { name: 'Total CWE Mass', value: 30 },
];

export const EMPIC_COLUMNS = [
  { name: 'EMPIC Code', value: 31 },
  { name: 'Product Description', value: 32 },
  { name: 'HTS Code', value: 33 },
  { name: 'Quantity', value: 34 },
  { name: 'Type', value: 35 },
  { name: 'Shipping Mark', value: 36 },
  { name: 'Container', value: 37 },
  { name: 'Seal', value: 38 },
  { name: 'Gross Weight', value: 39 },
  { name: 'Net Weight', value: 40 },
  { name: 'CWE Weight', value: 41 }
];

export const QUOTA_MANAGER_COLUMNS = [
  { name: 'Company Name', value: 42 },
  { name: 'Date', value: 43 },
  { name: 'Type', value: 44 },
  { name: 'Details', value: 45 },
  { name: 'Status', value: 46 },
  { name: 'Finance Status', value: 47 },
  { name: 'Finance Amount', value: 48 },
  { name: 'Quota Volume Debit', value: 49 },
  { name: 'Quota Volume Credit', value: 50 },
  { name: 'Quota Volume Balance', value: 51 }
];

export const TRANSACTION_MANAGER_COLUMNS = [
  { name: 'Transaction Date', value: 52 },
  { name: 'Transaction Type', value: 53 },
  { name: 'Invoice No', value: 54 },
  { name: 'Transaction Status', value: 55 },
  { name: 'Tonnes', value: 56 },
  { name: 'Fee', value: 57 },
  { name: 'Quantity', value: 58 },
  { name: 'Total Amount', value: 59 }
];

export const REPORT_LIST = [
  { name: 'EC Summary Monthly Report (1)', value: 1 },
  { name: 'Quota Year on Year Comparison (3)', value: 3 },
  { name: 'Quota Usage Statement : Allowance, Transfers & Certificate Activity (5)', value: 5 },
  { name: 'QH Summary : Activity Details, Destinations, Product Overview (6)', value: 6 },
  { name: 'Report (20) New Zealand Beef FTA', value: 11 },
  { name: 'Report (20a) Certificates of Origin', value: 9 },
  { name: 'Report (20b) Certificates of Origin', value: 10 },
]

export const WEEK_DAYS = [
  { value: 0, short: 'S', name: 'Sunday', selected: false },
  { value: 1, short: 'M', name: 'Monday', selected: true },
  { value: 2, short: 'T', name: 'Tuesday', selected: false },
  { value: 3, short: 'W', name: 'Wednesday', selected: false },
  { value: 4, short: 'T', name: 'Thursday', selected: false },
  { value: 5, short: 'F', name: 'Friday', selected: false },
  { value: 6, short: 'S', name: 'Saturday', selected: false }
];

export const DURATION = [
  { value: 1, label: 'Last 15 Days' },
  { value: 2, label: 'Last 1 Month' },
  { value: 3, label: 'Last 3 Months' },
  { value: 4, label: 'Last 6 Months' },
  { value: 5, label: 'Quota Start Date to Current Date' }
]

export enum ScheduleType {
  Report = 1,
  ReportBuilder = 2
}

export enum OccurrenceType {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export enum ReportScope {
  WholeYear = 1,
  DateSpecific = 2
}

export enum OrganisationReportType {
  RawData = 1,
  AnnualReport = 2,
  NZCustoms = 3
}

export const TEMPLATE_TYPE = [
  { name: 'Certificate', value: ReportBuilderType.Certificate },
  { name: 'Transaction', value: ReportBuilderType.Transaction },
]

export const SCHEDULER_TYPE = [
  { name: 'Reports', value: ScheduleType.Report },
  { name: 'Report Builder (Excel)', value: ScheduleType.ReportBuilder },
]

export const ENVIRONMENT_LIST = [
  { name: '--', value: '0', statusClass: '' },
  { name: 'DEVELOPMENT AND TESTING ONLY', value: '1', statusClass: "allocation-status-pill-success", },
  { name: 'STAGING TESTING', value: '2', statusClass: "allocation-status-pill-warning", },
  { name: 'UAT TESTING', value: '3', statusClass: "allocation-status-pill-info", },
]

export const TINYMCE_INIT = {
  plugins: [
    'anchor',
    'autolink',
    'charmap',
    'codesample',
    'emoticons',
    'image',
    'link',
    'lists',
    'media',
    'searchreplace',
    'table',
    'visualblocks',
    'wordcount'
  ],
  toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat',
  object_resizing: false,
  table_resize_bars: false,
  // Remove table quick toolbar
  table_toolbar: '',
  // Remove image quick toolbar if needed
  image_toolbar: '',
  // Disable all contextual toolbars
  quickbars_selection_toolbar: false,
  quickbars_insert_toolbar: false,
  // Prevent users from dropping images/files
  paste_data_images: false,
  // Keep styles/classes when editing
  valid_elements: '*[*]',
  extended_valid_elements: '*[*]'
} as const;

export const CRON_PRESETS = [
    { label: 'Every minute',        value: '* * * * *' },
    { label: 'Every 5 minutes',     value: '*/5 * * * *' },
    { label: 'Every 15 minutes',    value: '*/15 * * * *' },
    { label: 'Every 30 minutes',    value: '*/30 * * * *' },
    { label: 'Every hour',          value: '0 * * * *' },
    { label: 'Every 6 hours',       value: '0 */6 * * *' },
    { label: 'Daily at midnight',   value: '0 0 * * *' },
    { label: 'Daily at noon',       value: '0 12 * * *' },
    { label: 'Every Monday 9am',    value: '0 9 * * 1' },
    { label: 'Weekly (Sun midnight)',value: '0 0 * * 0' },
    { label: 'Monthly (1st)',        value: '0 0 1 * *' },
  ];

  export const PH_SEASON_BREAKDOWN = [
    { label: 'Mid Season', value: 1 },
    { label: 'End of Season', value: 2 },
  ];

  export enum ApplicationStatus {
    CanApply = 1,
    Applied = 2,
    WindowClosed = 3
  }